/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const layout_grid = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      clipPath="url(#layout_grid_svg__a)"
      clipRule="evenodd"
    >
      <path d="M1 1.933C1 1.418 1.418 1 1.933 1h3.734c.515 0 .933.418.933.933v3.734a.933.933 0 0 1-.933.933H1.933A.933.933 0 0 1 1 5.667V1.933Zm0 8.4c0-.515.418-.933.933-.933h3.734c.515 0 .933.418.933.933v3.734a.933.933 0 0 1-.933.933H1.933A.933.933 0 0 1 1 14.067v-3.734Zm8.4-8.4c0-.515.418-.933.933-.933h3.734c.515 0 .933.418.933.933v3.734a.933.933 0 0 1-.933.933h-3.734a.933.933 0 0 1-.933-.933V1.933Zm0 8.4c0-.515.418-.933.933-.933h3.734c.515 0 .933.418.933.933v3.734a.933.933 0 0 1-.933.933h-3.734a.933.933 0 0 1-.933-.933v-3.734Z" />
    </g>
    <defs>
      <clipPath id="layout_grid_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default layout_grid
